import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowUpRightFromSquare,
  faFolderOpen,
  faFileInvoiceDollar,
  faUserShield,
  faTasks,
  faComments,
  faFileAlt,
} from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../../context/AppContext';
import tutorialsData from '../../../assets/libraries/tutorials.json';
const CATEGORY_ICONS = {
  Projects: faFolderOpen,
  Billing: faFileInvoiceDollar,
  Admin: faUserShield,
  Workflow: faTasks,
  Support: faComments,
};

export const TutorialsPage = () => {
  const { user, token } = useAppContext();
  const isSuperAdmin = user?.is_super_admin === true;

  const tutorials = useMemo(
    () =>
      (tutorialsData.tutorials || []).filter(
        (tutorial) => isSuperAdmin || !tutorial.superAdminOnly
      ),
    [isSuperAdmin]
  );

  return (
    <div className="page">
      <div className="main-content">
        <div className="page-header">
          <h1>Tutorials</h1>
          <hr />
        </div>
        {!token && (
          <p className="tutorials-guest-nav">
            <Link to="/login" className="text-link">Back to login</Link>
            {' · '}
            <Link to="/signup" className="text-link">Create an account</Link>
          </p>
        )}
        <p className="tutorials-intro">
          Short walkthroughs for common portal workflows. Select a topic to open
          the recording in a new tab.
        </p>

        <div className="tutorials-grid">
          {tutorials.map((tutorial) => {
            const icon = CATEGORY_ICONS[tutorial.category] || faFileAlt;
            const hasUrl = Boolean(tutorial.url);
            const cardClassName = `tutorial-card${hasUrl ? '' : ' coming-soon'}`;
            const meta = (
              <span className={`tutorial-card-meta${hasUrl ? '' : ' coming-soon'}`}>
                {hasUrl && <FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
                {hasUrl ? 'Watch tutorial' : 'Coming soon'}
              </span>
            );
            const content = (
              <>
                <span className="tutorial-card-icon" aria-hidden="true">
                  <FontAwesomeIcon icon={icon} />
                </span>
                <p className="tutorial-card-category">{tutorial.category}</p>
                <h3 className="tutorial-card-title">{tutorial.title}</h3>
                <p className="tutorial-card-description">{tutorial.description}</p>
                {meta}
              </>
            );

            if (hasUrl) {
              return (
                <a
                  key={tutorial.id}
                  className={cardClassName}
                  href={tutorial.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {content}
                </a>
              );
            }

            return (
              <div key={tutorial.id} className={cardClassName} aria-disabled="true">
                {content}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
